const Graphs = () => {
  return (
    <>
      <div className="fw-medium fs-5 my-3">Graphs:</div>

      <div className="bg-white p-3">
        <div>Open Rate Over Time:</div>
        <ul>
          <li>Line graph showing open rates of different campaigns over time.
            Click-through Rate by Campaign:</li>
          <li>Bar graph comparing click-through rates across different campaigns.
            Conversion Rate Trend:</li>
          <li>Line graph illustrating conversion rate trends for each campaign.</li>
        </ul>
      </div>
    </>
  )
}

export default Graphs